module.exports = __webpack_public_path__ + "media/1_the_world.4e441f8c.mp3";